import Button from '../../app/design/Button'
import Modal from '../../app/design/Modal'

type Props = {
    isOpen: boolean
    onClose: () => void
    onConfirm: () => void
    title: React.ReactNode
    children: React.ReactNode
    cancelButtonText?: string
    confirmButtonText?: string
    size?: 'small' | 'medium' | 'large'
    isDestructive?: boolean
    shouldHideCancelButton?: boolean
    onCancel?: () => void
}

/**
 * Standard confirmation modal with default styles for the Confirm/Cancel buttons
 */
export function ConfirmationModal({
    isOpen,
    onClose,
    onConfirm,
    title,
    children,
    cancelButtonText,
    confirmButtonText,
    size = 'small',
    isDestructive = false,
    shouldHideCancelButton,
    onCancel,
}: Props) {
    return (
        <Modal
            size={size}
            width={size === 'small' ? 456 : undefined}
            title={title}
            isOpen={isOpen}
            onClose={onClose}
            showDividers={false}
            footer={
                <div className="flex w-full items-center justify-end gap-x-4">
                    {!shouldHideCancelButton && (
                        <Button
                            intent="tertiary_deprecated"
                            onClick={(e: React.MouseEvent) => {
                                e.stopPropagation()
                                if (!!onCancel) {
                                    onCancel()
                                }
                                else {
                                    onClose()
                                }
                            }}
                        >
                            {cancelButtonText ?? 'Cancel'}
                        </Button>
                    )}
                    <Button
                        intent={isDestructive ? 'destructive' : 'primary'}
                        onClick={(e: React.MouseEvent) => {
                            e.stopPropagation()
                            onConfirm()
                        }}
                    >
                        {confirmButtonText ?? 'Confirm'}
                    </Button>
                </div>
            }
        >
            <div className="mt-4 text-gray-600">{children}</div>
        </Modal>
    )
}
